// extracted by mini-css-extract-plugin
export default {"catalog":"catalog__2mZDs","catalogFooter":"catalogFooter__20Jkk","addockLink":"addockLink__3FnT2","addockLinkRed":"addockLinkRed__Q1qCb","addockLinkPurple":"addockLinkPurple__3E-Fg","noProducts":"noProducts__125jM"};
    if(module.hot) {
      // 1745482190540
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  